import React, { PureComponent } from "react";
import { downloadCSVData, downloadCanvasWithTitle, getViewConversationDuration } from "../utils";
import html2canvas from "html2canvas";
import moment from "moment-timezone";
import NoData from "../NoData/NoData";
import IntervalSelector from "../IntervalSelector";
import ConversationOverTimeWithAverageBandChart from "./ConversationOverTimeWithAverageBandChart";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { ChartFilterIcon } from "../ChartFilterOptions";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import ChartName from "../ChartName";
import { connect } from "react-redux";
import DownloadChart from "../DownloadChart";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";

import { ReactComponent as ComparisionIcon } from "../../../../../assets/svg/CompareChartIcon.svg";
import * as d3 from "d3";
class ConversationOverTimeWithAverageBand extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showGridLines: false,
        };
        this.chartEl = React.createRef();
    }

    dataTotals = (data) => {
        let total = new Array(data.xs.length).fill(0);
        Object.values(data.data).forEach((arr) => {
            arr.forEach((val, ind) => {
                total[ind] += val;
            });
        });
        return total;
    };

    formatData(data) {
        let res = {};
        let columns = [];
        let total = this.dataTotals(data);
        data.xs.forEach((d) => {
            columns;
        });
        columns.push(["x"].concat(data.xs));
        columns.push(["Total Conversations"].concat(total));
        res.columns = columns;
        return res;
    }

    getTimePeriodAverage(total) {
        let totalCount = total.length ? total.reduce((total, item) => total + item, 0) : 0;

        return (totalCount / total.length).toFixed(2);
    }

    // Average Bands
    getAvgBands(totals, tpAverage) {
        let values = [0, 0];

        let absAverages = 0;
        let diff = 0;

        if (totals.length > 1) {
            for (let i = totals.length - 1; i >= 1; i--) {
                diff = totals[i] - totals[i - 1];
                absAverages += Math.abs(diff);
            }
        } else {
            absAverages = totals[0];
        }

        absAverages = absAverages / totals.length;
        absAverages = absAverages * 2.66;

        values[0] = Math.round(tpAverage + absAverages).toFixed(0);
        values[1] = Math.round(tpAverage - absAverages).toFixed(0);

        return values;
    }

    addContextMenuListener = (x, y, chart) => {
        if (this.props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");

        contextMenu.attr("data-type", "clickedMenu");
        contextMenu.style("top", `${y + 10}px`);
        contextMenu.style("left", `${x - 82}px`);
        contextMenu.style("background", `#fff`);
        contextMenu.style("color", `#1a1a1a`);
        contextMenu.html(null);
        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                self.handleContextMenuClick(chart);
            });
        contextMenu
            .append("li")
            .text("View Insights")
            .on("click", () => {
                // console.log('drilldown')
                self.handleDrilldownClick(chart);
                // this.props.showChartsDrilldown(true, "conversationOverTimeWithAverageBand");
            });
        contextMenu.style("display", "block");
    };

    createNewFilter(d) {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};
        if (d.originalX) {
            d.x = d.originalX;
        }

        let lastComparisonIndex = false;
        lastComparisonIndex = d.index === d.series.points.length - 1 && d.color.endsWith("85");

        newFilter = getViewConversationDuration(
            d,
            newFilter,
            this.props.aggs_val,
            this.props.filters,
            this.props.comparisionData,
            lastComparisonIndex,
            this.props.comparisonAppliedFilter,
        );

        return newFilter;
    }

    handleContextMenuClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleContextMenuClick(newFilter);
    }

    handleDrilldownClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleDrilldownClick(newFilter);
    }

    formatDataCsv(data) {
        let res = {};
        let columns = [["x"], ["Total Conversations"]];
        data.chartData.forEach((val) => {
            columns[0].push(val.x);
            columns[1].push(val.y);
        });
        if (this.props.comparisionData) {
            columns.push(["Comparison Time"]);
            columns.push(["Comparison Total Conversations"]);
            this.props.comparisionData.chartData.forEach((d) => {
                columns[2].push(d.x);
                columns[3].push(d.y);
            });
        }
        res.columns = columns;

        return res;
    }

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let data = this.formatDataCsv(this.props.data);
        let formatString = "YYYY-MM-DD HH:mm";
        let userTz = JSON.parse(localStorage.getItem("company")).user_timezone_name;
        data.columns[0] = data.columns[0].map((d) => (d === "x" ? "x" : moment(d).tz(userTz).format(formatString)));
        if (this.props.comparisionData) {
            data.columns[2] = data.columns[2].map((d) => (d === "Comparison Time" ? "Comparison Time" : moment(d).tz(userTz).format(formatString)));
        }

        // let csvFmt;

        // if (this.props.comparisionData) {
        //     csvFmt = data.columns[3].map((col, i) => data.columns.map((row) => (row[i] ? row[i] : "  ")));
        // } else {
        //     csvFmt = data.columns[0].map((col, i) => data.columns.map((row) => row[i]));
        // }
        // //let csvFmt = data.columns[0].map((col, i) => data.columns.map((row) => row[i]));

        // csvFmt[0][0] = "time";

        // downloadCSVData(csvFmt, this.props.widget.name);

        let firstIndLen = data.columns[0].length;
        let lastIndLen = data.columns[data.columns.length - 1].length;

        let length;
        if (firstIndLen > lastIndLen) length = firstIndLen;
        else length = lastIndLen;

        let arr = [];
        for (let i = 0; i < length; i++) {
            arr.push([]);
            for (let j = 0; j < data.columns.length; j++) {
                if (data.columns[j] && data.columns[j][i]) arr[i].push(data.columns[j][i]);
                else arr[i].push(0);
            }
        }

        arr[0][0] = "Time";

        downloadCSVData(arr, this.props.widget.name);
    };

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }

        html2canvas(this.chartEl.current, { backgroundColor: options.background ? "#fff" : null }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    renderDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    }

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        name={this.props.widget.name}
                        info="The upper and lower average bands have been derived based on Radarr's computation of past data for the chosen topic/s. These represent the upper and lower threshold that topics normally fall under. Any deviations of data beyond these bands should indicate a period of very significant high or low social engagement activity."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <Popup
                                    content="Chart Comparison Filters"
                                    position="bottom center"
                                    size="tiny"
                                    inverted
                                    className="skiptranslate"
                                    trigger={
                                        <div className={`chart-header-icon`} onClick={() => (!this.props.isPublic ? this.props.chartComparision() : null)}>
                                            <ComparisionIcon className={`comparision-filter${this.props.chartComparisionFilterApplied ? "-applied" : ""}`} />
                                        </div>
                                    }
                                />
                            )}
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && this.renderDownloadButton(nodata)}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }

                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && <CustomCheckBox checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} label="Show Grid Lines" />}
                        {!nodata && (
                            <IntervalSelector
                                aggs_val={this.props.aggs_val}
                                appliedFilter={this.props.appliedFilter}
                                handleIntervalChange={this.props.handleIntervalChange}
                                disableComparisonInterval={this.props.disableComparisonInterval}
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart skiptranslate conversation-overtime-chart" ref={this.chartEl}>
                        <ConversationOverTimeWithAverageBandChart
                            data={this.props.data}
                            showGridLines={this.props.showGridLines}
                            // resizedCount={this.props.resizedCount}
                            addContextMenuListener={this.addContextMenuListener}
                            comparisionData={this.props.comparisionData}
                            widgetContainerRef={this.props.widgetContainerRef}
                        />
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        allPlatforms: state.filterSettingReducer.masterPlatforms,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConversationOverTimeWithAverageBand);
